import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { is_upload_image_to_grid_possible } from '@/utils/utils_grid2d';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { GRID2D_CELL__empty } from './GRID2D_CELL__empty';
import { GRID2D_CELL__image_content_or_empty } from './GRID2D_CELL__image_content_or_empty';
import { GRID2D_CELL__loading_image } from './GRID2D_CELL__loading_image';
import { GRID2D_CELL__upload } from './GRID2D_CELL__upload';

interface PROPS {
  index: number;
  //
  width: number;
  height: number;
  //
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
  grid2d_virtual: DTO__grid2d_virtual;
  ui_grid2d_cells_sort_newest_first: boolean;
  use_offset_from_slug: boolean;
  //
  can_show_buttons?: boolean;
}

export function GRID2D_CELL__float({
  index,
  //
  width,
  height,
  //
  grid2d,
  grid2d_virtual,
  entity,
  //
  ui_grid2d_cells_sort_newest_first,
  use_offset_from_slug,
  can_show_buttons = true,
}: PROPS) {
  function render_cell_empty() {
    let out = <></>;

    if (is_upload_image_to_grid_possible(entity)) {
      out = <GRID2D_CELL__upload {...{ grid2d, height, width }} />;
    } else {
      out = <GRID2D_CELL__empty is_hovered={false} {...{ width, height }} />;
    }

    return out;
  }

  function render_cell() {
    if (index === CONSTANTS__client.VIRTUAL_ITEM_STUB_INDEX) return render_cell_empty();
    if (isNaN(index)) return render_cell_empty();

    if (grid2d_virtual.cells__amount__grid2d_total === 0) return null;

    let index_new = ui_grid2d_cells_sort_newest_first ? grid2d_virtual.cells__amount__grid2d_total - 1 - index : index;

    index_new = Math.min(grid2d.total_cells_amount - 1, index_new);
    index_new = Math.max(0, index_new);

    index_new = Math.max(0, index_new);

    index_new = grid2d.total_cells_amount - index - 1;

    let cell = grid2d.cell__get_by_index(index);

    if (cell.is_stub()) {
      return <GRID2D_CELL__loading_image {...{ width, height }} />;
    } else {
      return <GRID2D_CELL__image_content_or_empty {...{ cell, grid2d, entity, height, width, use_offset_from_slug, can_show_buttons }} />;
    }
  }

  if (grid2d_virtual.is_stub()) return null;

  return render_cell();
}
